var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!!_vm.subText)?_c('v-list-item-content',[_c('v-list-item-title',[_vm._v(_vm._s(_vm.itemText))]),_c('v-list-item-subtitle',[_vm._v(_vm._s(_vm.subText))])],1):_c('span',{staticClass:"text"},[_vm._v(" "+_vm._s(_vm.itemText)+" ")])}
var staticRenderFns = []

export { render, staticRenderFns }